import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import { formatDate } from '../../../utils/formatters';

const UpcomingDeadlines = ({ deadlines }) => {
  const { t } = useTranslation('dashboard');
  const getUrgencyColor = (daysLeft) => {
    if (daysLeft <= 3) return 'text-error bg-error-subtle';
    if (daysLeft <= 7) return 'text-warning bg-warning-subtle';
    return 'text-success bg-success-subtle';
  };

  const formatDeadline = (dateString) => {
    return formatDate(dateString);
  };

  const calculateDaysLeft = (dateString) => {
    return Math.ceil((new Date(dateString) - new Date()) / (1000 * 60 * 60 * 24));
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="px-4 py-2.5 border-b border-border flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground">{t('upcomingDeadlines.title')}</h3>
        <Icon name="Clock" size={14} className="text-muted-foreground" />
      </div>
      <div className="divide-y divide-border">
        {deadlines?.map((deadline) => {
          const daysLeft = calculateDaysLeft(deadline?.date);
          return (
            <div key={deadline?.id} className="px-4 py-2.5 flex items-center justify-between gap-3">
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground truncate">{deadline?.title}</p>
                <p className="text-xs text-muted-foreground">{deadline?.conference} &middot; {formatDeadline(deadline?.date)}</p>
              </div>
              <span className={`text-xs font-medium px-2 py-0.5 rounded-md whitespace-nowrap ${getUrgencyColor(daysLeft)}`}>
                {daysLeft > 0 ? t('upcomingDeadlines.daysLeft', { count: daysLeft }) : t('upcomingDeadlines.overdue')}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpcomingDeadlines;
